module.exports = __webpack_public_path__ + "static/media/haute13A.70aeb8c0.jpg";